import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Input, Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';
import { B } from 'components/Layout';

export const Column = styled(Grid.Column)`
  margin-bottom: -24px;
`;

export const Row = styled(Grid.Row)`
  margin-bottom: -24px;
  display: inline-block;
  position: relative;
`;

export const SearchInput = ({ label, onBlur, value, onChange, placeholder }) => (
  <div>
    <B>{label}</B>
    <Input fluid value={value} onBlur={onBlur} onChange={onChange} placeholder={placeholder} />
  </div>
);

SearchInput.propTypes = {
  label: PropTypes.string,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

export const SearchSelect = ({ label, onChange, options, placeholder, value }) => (
  <div>
    <B>{label}</B>
    <Dropdown
      value={value}
      onChange={onChange}
      search
      fluid
      placeholder={placeholder}
      selection
      options={options}
    />
  </div>
);

SearchSelect.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  value: PropTypes.any,
};



// WEBPACK FOOTER //
// ./app/components/Pratiche/ClassicMode/AdvancedSearch/components.js